import { NgModule } from '@angular/core';

import { CuitPipe } from './cuit.pipe';
import { FirstPipe } from './first.pipe';


@NgModule({
    declarations: [
        CuitPipe,
        FirstPipe
    ],
    imports     : [],
    exports     : [
        CuitPipe,
        FirstPipe
    ]
})
export class RossPipesModule {
}
